// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3pEoX","legacyBtn":"MutateMid_legacyBtn__1P9AE"};